import { createFileRoute, redirect } from "@tanstack/react-router";

/** Spaces is Xamseen's name for the community layer. */
export const Route = createFileRoute("/spaces")({
  beforeLoad: () => { throw redirect({ to: "/communities" }); },
});
